import PropTypes from "prop-types";

function HelperText({ children }) {
  return <div className="help-text text-center text-large">{children}</div>;
}

HelperText.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HelperText;
